import { CustomHeader } from 'components/universal/custom-header';
import { useTranslation } from 'react-i18next';
import { RegistrationView } from 'views/registration';

export const Registration = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'SEO.registration',
    });

    return (
        <>
            <CustomHeader title={t('title')} />
            <RegistrationView />
        </>
    );
};
